/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 */
import { useEffect, useRef, useState } from "react";
import Reveal from "./Reveal";
import { STATS } from "./landing.data";

function useCountUp(target, active, duration = 1600) {
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!active) return undefined;
    let raf = 0;
    const start = performance.now();

    const tick = (now) => {
      const p = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setValue(Math.round(target * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };

    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, active, duration]);

  return value;
}

function StatItem({ item, isArabic, active }) {
  const value = useCountUp(item.value, active);
  return (
    <div className="gl-stat">
      <span className="gl-stat__value">
        {value.toLocaleString(isArabic ? "ar-IQ" : "en-US")}
        {item.suffix}
      </span>
      <span className="gl-stat__label">
        {isArabic ? item.labelAr : item.labelEn}
      </span>
    </div>
  );
}

export default function StatsSection({ isArabic }) {
  const ref = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setActive(true);
          io.disconnect();
        }
      },
      { threshold: 0.35 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <section className="gl-section" id="stats" style={{ paddingTop: 0 }}>
      <div className="gl-shell">
        <Reveal>
          <div className="gl-stats" ref={ref}>
            {STATS.map((item) => (
              <StatItem
                key={item.key}
                item={item}
                isArabic={isArabic}
                active={active}
              />
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
